module.exports = __webpack_public_path__ + "80d77e74c5c50d48f59f54d421b0c1ca.jpg";